import { SupportingActivityFormModel, SupportingActivityItemModel, SupportingActivitySummaryItemModel } from '../../api/models';
import { map } from 'lodash';

const applicationActivityType = (values: SupportingActivityFormModel) => values && values.applicationActivityType ? [...values.applicationActivityType] : [];

const createDefaultItem = (values: SupportingActivityFormModel): Partial<SupportingActivityItemModel> => {
    return {
        id: 0,
        name: '',
        briefDescription: '',
        referenceNumber: undefined,
        duration: {
            endMonth: undefined,
            endYear: undefined,
            startMonth: undefined,
            startYear: undefined,
        },
        coreActivities: values.coreActivities ? [...values.coreActivities] : [],
        activityRelations: [
            {
                activityId: undefined,
            },
        ],
        levyCollectingRspItems: values.levyCollectingRspItems,
        rspNonLevyItems: values.rspNonLevyItems,
        crcItems: values.crcItems,
        otherOrganisation: 'No',
        otherOrganisationName: '',
        applicationActivityType: applicationActivityType(values),
        applicationHasIncludedExcludedActivities: values.applicationHasIncludedExcludedActivities,
        excluded: undefined,
        relatedGoodsAndServices: undefined,
        supportCoreActivity: undefined,
        actionsStepsCompleted: '',
        incomePeriodDateRange:  {
            ...values.incomePeriodDateRange,
        },
        allOtherSubActivitiesForThisApp: [],
        totalExpenditure: undefined,
        supportForCoreActivities: undefined,
        availableCrcs: values.availableCrcs,
        availableLevyRsps: values.availableLevyRsps,
        availableNonLevyRsps: values.availableNonLevyRsps,
        isIntentionPreviouslyRegisteredSupportingRNDActivityApplication: undefined,
        nameRNDEntityPerformingSupportingActivity: '',
        isEntityWhoWillConductSupportingConnected: undefined,
        isSupportingActivityConductedUnderAgreementOutsideAus: undefined,
        activityConductedBy: undefined,
        subsidiaryConductingActivity: undefined,
        explainWhyHowSupportingActivityUndertaken: '',
        evidenceAvailable: '',
        activityPerformedBy: undefined,
        organisationMecType: values.organisationMecType,
        afiRnDEntityABN: values.afiRnDEntityABN,
        organisationUhcAbn: values.organisationUhcAbn,
        primaryTaxAgentAbn: values.primaryTaxAgentAbn,
    };
};

const getAllOtherSupportingActivities = (values: SupportingActivityFormModel): Partial<string>[] => {
    return [
        ...map(values.items, i => i.name!),
        ...map(values.coreActivities, i => i.name!),
    ];
};

export const supportingActivityDetailsItem = (values: SupportingActivityFormModel): Partial<SupportingActivityItemModel> => {
    return {
        ...createDefaultItem(values),
        allOtherSubActivitiesForThisApp: getAllOtherSupportingActivities(values),
    };
};

export const supportingActivitySummaryItem = (_values: SupportingActivityFormModel): Partial<SupportingActivitySummaryItemModel> => {
    return {
        referenceNumber: ' ',
        end: ' ',
        id: 0,
        issues: undefined,
        name: ' ',
        start: ' ',
    };
};
